

.heading:hover {
  cursor: pointer;
}
.heading {
  border-bottom: 1px solid var(--static-divider-standard);
}

.content {
  transition: height 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  height: auto;
  overflow: hidden;
}
.content[data-collapsed=true] {
  height: 0px;
}
.content > *:first-child {
  margin-top: 10px;
}